import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import InfiniteScroll from 'redux-infinite-scroll-sf'

import HeaderLockup from '../components/mini/HeaderLockup'
import NoQuestsAssignedToYou from '../components/mini/NoQuestsAssignedToYou'
import Quests from '../components/Quests'
import NoQuestsMatchYourSearch from '../components/mini/NoQuestsMatchYourSearch'
import QuestsSearchResultsCount from '../components/mini/QuestsSearchResultsCount'
import UserAvatar from '../components/mini/UserAvatar'
import SearchFilters from '../components/queue/SearchFilters'
import Sort from '../components/mini/Sort'

import { fetchUserAssignments, setSort } from '../actions/queue'
import { getUserData } from '../actions/user'

import { courseLevels } from '../selectors/courselevels'
import { currentOrg } from '../selectors/organization'
import { getqdUsers } from '../selectors/users'
import { isQuestManager } from '../utils/user'

class QueueContainer extends Component {
  constructor(props) {
    super(props)
    this.loadMoreQuestsBound = this.loadMoreQuests.bind(this)
    this.handleSortClickBound = this.handleSortClick.bind(this)
  }

  componentDidMount() {
    this.props.dispatch(fetchUserAssignments(1, true))
    this.props.dispatch(getUserData())
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.orgId !== this.props.orgId) {
      setTimeout(() => {
        this.props.dispatch(fetchUserAssignments(1, true))
        this.props.dispatch(getUserData())
      }, 100)
    }
  }

  render() {
    const {
      dispatch,
      isFetching,
      quests,
      user,
      sort,
      stats,
      total,
      organization
    } = this.props

    return (
      <div className="queue-container">
        <HeaderLockup
          avatarComponent={<UserAvatar photoUrl={user.photo.url} />}
          organization={organization}
          section="Quests Assigned to Me"
        />

        <div className="queue-wrapper">
          <div className="queue-menu">
            <SearchFilters
              {...this.props}
              isQuestManager={isQuestManager(user)}
            />
          </div>

          <div className="queue-body">
            {!isFetching && quests && quests.length > 0 && (
              <QuestsSearchResultsCount totalQuests={total} />
            )}
            {(isFetching || (quests && quests.length > 0)) && (
              <Sort
                sort={sort}
                onClick={this.handleSortClickBound}
                desc="assignment_updated_at desc"
                asc="assignment_updated_at asc"
              />
            )}
            {quests && quests.length > 0 && (
              <InfiniteScroll
                items={
                  <Quests
                    quests={quests}
                    dispatch={dispatch}
                    user={user}
                    iconHeightWidth={82}
                  />
                }
                loadMore={this.loadMoreQuestsBound}
                loadingMore={isFetching}
                elementIsScrollable={false}
                showLoader={false}
              />
            )}
            {!isFetching && stats && stats.assigned_quests_count === 0 && (
              <NoQuestsAssignedToYou />
            )}
            {!isFetching &&
              quests &&
              quests.length === 0 &&
              stats &&
              stats.assigned_quests_count > 0 && (
                <NoQuestsMatchYourSearch text="No quests assigned to you match your search." />
              )}
            {isFetching && quests && quests.length === 0 && (
              <div className="loading" />
            )}
          </div>
        </div>
      </div>
    )
  }

  loadMoreQuests() {
    // Only load more quests if the size of the quest list is less than the totalquest count from the search call
    if (this.props.quests.length < this.props.total) {
      this.props.dispatch(fetchUserAssignments(this.props.page + 1, false))
    }
  }

  async handleSortClick(e) {
    const { dispatch } = this.props
    await dispatch(setSort(e.currentTarget.dataset.ref))
    dispatch(fetchUserAssignments(1, true))
  }
}

QueueContainer.propTypes = {
  isFetching: PropTypes.bool,
  quests: PropTypes.array,
  user: PropTypes.object,
  dispatch: PropTypes.func,
  orgId: PropTypes.number,
  authorsFilter: PropTypes.array,
  titleFilter: PropTypes.string,
  qdUsers: PropTypes.array,
  sort: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  stats: PropTypes.object.isRequired,
  organization: PropTypes.object,
  draftFilterSelected: PropTypes.bool,
  statusFilters: PropTypes.array,
  allStatusChecked: PropTypes.bool,
  keywordFilter: PropTypes.string.isRequired,
  gradeLevels: PropTypes.array.isRequired,
  gradeFilters: PropTypes.array.isRequired,
  isFetchingGrades: PropTypes.bool.isRequired
}

export const mapStateToProps = state => ({
  isFetching: state.queue.isFetching,
  quests: state.queue.items,
  user: state.user.user,
  orgId: state.organization.orgId,
  authorsFilter: state.queuefilters.authors_id_in,
  titleFilter: state.queuefilters.name_or_description_cont,
  qdUsers: getqdUsers(state),
  sort: state.queue.sort,
  page: state.queue.page,
  total: state.queue.total,
  stats: state.user.stats,
  organization: currentOrg(state),
  draftFilterSelected:
    state.queuefilters.reviewing_compiled_quest_state_null !== null,
  statusFilters: state.queuefilters.reviewing_compiled_quest_state_in || [],
  keywordFilter: state.queuefilters.name_or_description_cont || '',
  allStatusChecked:
    !state.queuefilters.reviewing_compiled_quest_state_null &&
    state.queuefilters.reviewing_compiled_quest_state_in.length === 0,
  courses: state.mockcourses.items,
  courseFilter: state.queuefilters.mock_course_id_in,
  levelFilters: state.queuefilters.mock_level_id_in || [],
  levels: courseLevels(state, state.queuefilters.mock_course_id_in),
  gradeLevels: state.gradelevels.items,
  gradeFilters: state.queuefilters.grade_levels_id_in,
  isFetchingGrades: state.gradelevels.isFetching
})

export default connect(mapStateToProps)(QueueContainer)
export { QueueContainer as QueueContainerDisconnected } // pure component for testing



// WEBPACK FOOTER //
// ./src/containers/Queue.js